import { vasChargesActions } from './vasChargesActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashBoardData: [],
  addresses: [],
  vehicleNumber: null,
  vehicleType: null,
  error: null,
  pageNumber: 0,
  pageSize: 20,
  totalElements: 0,
  vehicleTypesOptions: null,
  totalCharge: null,
  receiptUrl: null,
  emailEvidenceUrl: null,
  filters: {}
};

const vasChargesReducer = (state = initialState, action) => {
  switch (action.type) {
    case vasChargesActions.GET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case vasChargesActions.UPDATE_PAGE_NUMBER: {
      return Object.assign({}, state, { pageNumber: action.payload });
    }

    case vasChargesActions.UPDATE_FILTER: {
      return Object.assign({}, state, {
        filters: Object.assign(state.filters, { [action.key]: action.payload })
      });
    }

    case vasChargesActions.TOGGLE_ADDRESS_SELECT: {
      return Object.assign({}, state, {
        addresses: Object.assign(state.addresses, {
          ...action.payload
        })
      });
    }

    case vasChargesActions.TOGGLE_CNOTE_SELECT: {
      return Object.assign({}, state, {
        addresses: Object.assign(state.addresses, {
          [action.key]: action.payload
        })
      });
    }

    case vasChargesActions.RESET_FORM: {
      return Object.assign({}, state, {
        ...action.payload
      });
    }

    case vasChargesActions.UPDATE_FORM: {
      return Object.assign({}, state, {
        ...action.payload
      });
    }

    default: {
      return state;
    }
  }
};

export default vasChargesReducer;
